export const skillsData = [
    'Java',
    'Spring Boot',
    'Spring Security',
    'Spring Cloud',
    'Microservices',
    'Angular',
    'TypeScript',
    'JavaScript',
    'REST APIs',
    'Docker',
    'Kubernetes',
    'AWS',
    'Azure',
    'Jenkins',
    'Harness',
    'Oracle',
    'MySQL',
    'JUnit',
    'Mockito',
    'SonarQube',
    'Git',
]
